import { render, staticRenderFns } from "./hbfx.vue?vue&type=template&id=5cc4701d"
import script from "./hbfx.vue?vue&type=script&lang=js"
export * from "./hbfx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports